
import AppReminderLayoutEditor from "@/components/reminder-layout-editor/ReminderLayoutEditor.vue";
import { ReminderLayoutConf } from "@/models/reminder-layout";
import { ReminderService } from "@/services/reminder-service";
import Vue from "vue";
let defaultReminderLayout = require("@/assets/json/default-reminder-layout.json");

export default Vue.extend({
	data() {
		return {
			layout: new ReminderLayoutConf(),
			ready: false
		};
	},
	methods: {
		async save() {
			if (this.layout.ID == 0 || this.layout.ID == undefined) {
				[this.layout] = await ReminderService.postReminderLayout([this.layout]);
			} else {
				[this.layout] = await ReminderService.putReminderLayout([this.layout]);
			}
			this.$wf.notify(this.$ct("layout-save-success").toString(), "success", 3000, "check");
		},
		getNewReminderLayoutData(): any {
			return JSON.parse(JSON.stringify(defaultReminderLayout));
		}
	},
	async mounted() {
		if (this.$route.params.id) {
			this.layout = await ReminderService.getReminderLayout(parseInt(this.$route.params.id));
		} else {
			this.layout = new ReminderLayoutConf(this.getNewReminderLayoutData());
		}
		this.ready = true;
	},
	components: {
		AppReminderLayoutEditor
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
